'use strict';

var themes = require('@wow/themes');

const {
  colors: {
    primary,
    white,
    secondary,
    blackAlpha
  },
  sizes,
  radii
} = themes.themeChakra;
const checkboxStyle = {
  control: {
    borderColor: secondary[400],
    backgroundColor: white,
    borderRadius: radii[4],
    borderWidth: 1,
    width: sizes[24],
    height: sizes[24],
    _hover: {
      background: secondary[50]
    },
    _focusVisible: {
      background: secondary[50],
      boxShadow: 'none'
    },
    _checked: {
      background: primary[500],
      color: white,
      borderColor: primary[500],
      _hover: {
        background: primary[400],
        borderColor: primary[400],
        _disabled: {
          opacity: 0.4
        }
      },
      _focusVisible: {
        background: primary[400]
      },
      _active: {
        background: primary[500],
        borderColor: primary[500]
      },
      _disabled: {
        background: primary[500],
        color: white,
        borderColor: primary[500],
        opacity: 0.4,
        _hover: {
          background: primary[500],
          borderColor: primary[500],
          color: white
        }
      }
    },
    _indeterminate: {
      background: primary[500],
      color: white,
      borderColor: primary[500],
      _hover: {
        background: primary[400],
        borderColor: primary[400]
      },
      _focusVisible: {
        background: primary[400],
        borderColor: primary[400]
      },
      _active: {
        background: primary[500],
        borderColor: primary[500]
      },
      _disabled: {
        background: primary[500],
        color: white,
        borderColor: primary[500],
        opacity: 0.4,
        _hover: {
          background: primary[500],
          borderColor: primary[500],
          color: white
        }
      }
    },
    _disabled: {
      borderColor: secondary[400],
      backgroundColor: white,
      opacity: 0.4,
      _hover: {
        borderColor: secondary[400],
        background: secondary[50],
        color: blackAlpha[100]
      },
      _active: {
        borderColor: secondary[50],
        background: blackAlpha[100],
        color: blackAlpha[100]
      }
    }
  },
  label: {
    color: secondary[900]
  },
  icon: {
    fontSize: '0.6875rem'
  }
};
const baseStyle = checkboxStyle;
const CheckboxChakra = {
  baseStyle,
  defaultProps: {
    variants: null,
    size: null
  }
};

exports.CheckboxChakra = CheckboxChakra;
exports.checkboxStyle = checkboxStyle;
